import { queryClient } from '../../query';
import { callGetApi } from '../apiCallerProxy';
import { createResourcesApi } from './resourcesApiFactory';

export * from './hooks';
export default createResourcesApi({ callGetApi, queryClient });
